import { ICommonSettings, IFirebaseSetting } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigFirebaseSettings, FIREBASE_SETTINGS_SEARCH_TERMS } from "./app-settings-config-firebase";

export interface IConfigFirebaseInputState {
  showModal: boolean;
  editingFirebaseId: string;
}

export interface IConfigFirebaseInputProps {
  parentData: string;
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigFirebaseInput extends PureComponent<IConfigFirebaseInputProps, IConfigFirebaseInputState> {
  formInputName = ["", "firebaseSettingsId"];

  constructor(props: IConfigFirebaseInputProps) {
    super(props);
    this.formInputName[0] = this.props.parentData;
    this.state = {
      showModal: false,
      editingFirebaseId: ""
    };
  }

  openModal = () => {
    this.setState({ editingFirebaseId: "", showModal: true });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingFirebase = (id: string) => {
    this.setState({ editingFirebaseId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const {
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;

    const options = [
      { id: null, name: "Default" } as unknown as IFirebaseSetting,
      ...(commonSettings.firebaseSettings || [])
    ];

    return (
      <>
        <ConfigFirebaseSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingFirebaseId={this.state.editingFirebaseId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />

        <ConfigSettingSelect
          searchTerms={FIREBASE_SETTINGS_SEARCH_TERMS}
          label="Settings"
          formInputName={this.formInputName}
          options={options}
          tooltipContentKey={this.props.parentData === "androidConfig" ? "android_pushnotification_settings" : ""}
          onAddNew={this.openModal}
          onEdit={this.setEditingFirebase}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="androidPushNotificationSettingsDropdown"
          addNewTestId="androidPushNotificationSettingsAddNewButton"
          editTestId="androidPushNotificationSettingsEditButton"
        />
      </>
    );
  }
}
